<template>
  <div class="page">
    <a-card :bordered="false" title="装修市场" :bodyStyle="{paddingTop:'0px',paddingBottom:'0px'}"
            :headStyle="{borderBottom:'0px',fontSize:'18px'}" style="margin-bottom:15px;">
      <a-form>
        <a-form-item label="所属类目" v-bind="formItemLayout" style="margin-bottom:0;">
          <ul class="lable-ul">
            <li v-for="(item,index) in tenant" @click="onApplyId(item.value,index)" :key="index"
                :class="{'active':index==isSelect}">{{ item.label }}
            </li>
          </ul>
        </a-form-item>
        <a-form-item label="收费价格" v-bind="formItemLayout" style="margin-bottom:0;">
          <ul class="lable-ul">
            <li v-for="(item,index) in price" @click="onFeeId(item.value,index)" :key="index"
                :class="{'active':index==isFee}">{{ item.label }}
            </li>
          </ul>
        </a-form-item>
        <a-form-item label="颜色" v-bind="formItemLayout" style="margin-bottom:0;">
          <ul class="lable-ul">
            <li v-for="(item,index) in items" @click="onColorId(item.value,index)" :key="index"
                :class="{'active':index==isColor}">{{ item.label }}
            </li>
          </ul>
        </a-form-item>
      </a-form>
    </a-card>
    <a-list :loading="loading" :data-source="marketModuleList"
            :grid="{ gutter: 24, xxl: 4, xl: 3, lg: 2, md: 2, sm: 2, xs: 1 }">
      <a-list-item slot="renderItem" slot-scope="item">
        <a-card class="ant-pro-pages-account-projects-card" hoverable>
          <div class="image-box" slot="cover" @click="previewImg(item.templateImg)">
            <img :src="item.templateImg" alt=""/>
          </div>
          <a-card-meta :title="item.templateName">
            <template slot="description">{{ item.templateDesc }}</template>
          </a-card-meta>
          <div class="cardItemContent">
            <span v-if="item.priceAmount&&item.priceAmount!=0" class="price">{{ item.priceAmount }}元/月</span>
            <span v-else>免费</span>
            <a @click="onBuyModuleInfo(item.templateId,item.templateName)">立即购买</a>
          </div>
        </a-card>
      </a-list-item>
    </a-list>
    <!-- 模板价格 -->
    <a-modal title="订购模板"
             :visible="priceOrderVisible"
             @ok="handleOrderBtns"
             :confirmLoading="confirmLoading"
             @cancel="handleCancel"
    >
      <div class="lh30">模板ID：{{ priceForm.templateId }}，名称：{{ priceForm.templateName }}</div>
      <a-radio-group @change="onChange" v-model="priceForm.priceValidTime">
        <a-radio :style="radioStyle" v-for="(item,index) in priceList" :key="index" :value="item.priceValidTime">
          {{ item.priceDesc }}
        </a-radio>
      </a-radio-group>
    </a-modal>
    <!-- 价格 -->
    <a-modal title="微信支付"
             :visible="paydialogVisible"
             @cancel="handlePayCancel"
             :footer="null"
    >
      <div class="price-img">
        <img :src="erWeiMaImageSrc" alt="">
      </div>
      <p class="text-txt">微信扫一扫，完成支付</p>
    </a-modal>
    <!-- 图片预览 -->
    <PreviewImage v-if="imgDialogVisible" :dialogVisible="imgDialogVisible" :imageUrl="imageUrl"
                  @close="closeData"></PreviewImage>
  </div>
</template>

<script>
import PreviewImage from '../component/PreviewImage'

export default {
  name: 'Market',
  components: {
    PreviewImage
  },
  data() {
    return {
      imageUrl: '',
      loading: true,
      confirmLoading: false,
      paydialogVisible: false,
      imgDialogVisible: false,
      isSelect: 0,
      isFee: 0,
      isColor: 0,
      items: [  // ‘颜色选择’
        { label: '不限', value: 0 },
        { label: '橙色', value: 1 },
        { label: '绿色', value: 2 },
        { label: '红色', value: 3 },
        { label: '黑色', value: 4 },
        { label: '黄色', value: 5 },
        { label: '蓝色', value: 6 },
        { label: '青色', value: 7 },
        { label: '白色', value: 8 }
      ],
      tenant: [   // ‘平台类型’
        { value: 0, label: '不限' },
        { value: 1, label: '全国平台型' },
        { value: 2, label: '区域周边型' },
        { value: 3, label: '酒店连锁' },
        { value: 4, label: '单体景区' },
        { value: 5, label: '单体酒店' },
        { value: 6, label: '旅行社单店' },
        { value: 7, label: '其他' }
      ],
      price: [  // ‘价格’
        { value: 0, label: '不限' },
        { value: 1, label: '免费' },
        { value: 2, label: '收费' }
      ],
      formItemLayout: {
        labelCol: {
          xxl: { span: 1 },
          xl: { span: 2 },
          lg: { span: 2 },
          sm: { span: 2 },
          md: { span: 4 },
          xs: { span: 4 }
        },
        wrapperCol: {
          xxl: { span: 23 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 22 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 22 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 22 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 20 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 20 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      // 查询条件
      searchForm: {
        templateApply: 0,//适用商户: 0 不限 1全国平台型 2区域周边型 3酒店连锁 4单体景区 5单体酒店 6旅行社单店 7其他 ,
        templateColor: 0,//模板颜色 0不限 1 红色 2 蓝色 3绿色 4橙色 ,
        templateEarnings: 0,//模板是否收费:1免费 2收费
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      marketModuleList: [],
      priceOrderVisible: false,
      priceForm: {
        templateId: '',
        templateName: '',
        priceValidTime: 12,//默认选中12个月
        priceAmount: 0,
        platformId: '',
        merchantId: ''
      },
      priceList: [],
      orderNo: '',
      timer: null,
      erWeiMaImageSrc: '',//微信二维码
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId
    }
  },
  activated() {
    this.loading = true
    this.getMarketModule()
    this.getLogUtils().logWithTag('getAppConfig', this.getAppConfig())
  },
  deactivated() {
    this.clearTime()
  },
  mounted() {
  },
  methods: {
    // 关闭图片预览
    closeData() {
      this.imageUrl = ''
      this.imgDialogVisible = false
    },
    // 点击图片预览
    previewImg(imgUrl) {
      this.imgDialogVisible = true
      this.imageUrl = imgUrl
    },
    onChange(e) {
      this.getLogUtils().logWithTag('onChange', e.target.value)
      this.priceForm.priceValidTime = e.target.value
      this.changePriceType(this.priceForm.priceValidTime)
    },
    handleCancel() {
      this.priceOrderVisible = false
    },
    handlePayCancel() {
      this.paydialogVisible = false
      this.clearTime()
    },
    //适用商户
    onApplyId(value, index) {
      this.loading = true
      this.searchForm.templateApply = value
      this.isSelect = index
      this.getMarketModule()
    },
    //模板颜色
    onColorId(value, index) {
      this.loading = true
      this.searchForm.templateColor = value
      this.isColor = index
      this.getMarketModule()
    },
    //模板是否收费
    onFeeId(value, index) {
      this.loading = true
      this.searchForm.templateEarnings = value
      this.isFee = index
      this.getMarketModule()
    },
    getMarketModule() {
      this.getHttpServices().getSmsApiService().post('templateStyle/queryList/1/100', this.searchForm).then(res => {
        this.loading = false
        this.getLogUtils().logWithTag('getMarketModule', res)
        this.marketModuleList = res.data
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 点击购买
    onBuyModuleInfo(templateId, name) {
      this.priceOrderVisible = true
      this.priceForm.priceValidTime = 12
      this.priceForm.templateId = templateId
      this.priceForm.templateName = name
      this.getHttpServices().getSmsApiService().post('templateStyle/queryPriceList/' + templateId).then(res => {
        this.getLogUtils().logWithTag('onBuyModuleInfo', res)
        this.priceList = res
        this.$nextTick(() => {
          this.changePriceType(this.priceForm.priceValidTime)
        })
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 获取价格
    changePriceType(id) {
      let price = 0
      this.priceForm.priceAmount = 0
      try {
        price = this.priceList.filter(item => {
          return item.priceValidTime == id
        })[0].priceAmount
      } catch (err) {
        this.getLogUtils().logWithTag('错误', 'error submit!!')
      }
      this.priceForm.priceAmount = price
      this.getLogUtils().logWithTag('模板价格', this.priceForm.priceAmount)
    },
    handleOrderBtns() {
      if (!this.priceForm.priceValidTime) {
        this.$message.error('请选择订购方式')
        return
      }
      this.priceForm.platformId = this.platformId
      this.priceForm.merchantId = this.merchantId
      this.confirmLoading = true
      this.getLogUtils().logWithTag('handleOrderBtns', this.priceForm)
      this.getHttpServices().getInterPayApiService().post('templateStyle/order/pay/templateStyle', this.priceForm).then(res => {
        this.getLogUtils().logWithTag('handleOrderBtns', res)
        this.priceOrderVisible = false
        this.orderNo = res
        //如果模板价格为0
        if (this.priceForm.priceAmount == 0) {
          this.$message.success('模板订购成功')
          this.getMarketModule()
        } else {
          this.showErWeiMa(this.orderNo)
          this.paydialogVisible = true
          this.checkPayStatus(this.orderNo)
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.confirmLoading = false)
    },
    // 获取二维码
    showErWeiMa(orderNo) {
      if (orderNo) {
        this.erWeiMaImageSrc = this.getAppConfig().interPayUrl + 'pay/order/qrcode/pay/' + orderNo + '/5'
      }
    },
    // 微信查询
    checkPayStatus(orderNo) {
      if (!this.timer) {
        this.timer = setInterval(() => {
          this.getTemplateStyleIsOk(orderNo)
        }, 1000)
      }
    },
    getTemplateStyleIsOk(orderNo) {
      this.getHttpServices().getInterPayApiService().post('templateStyle/order/pay/templateStyleIsOk/' + orderNo).then(res => {
        this.getLogUtils().logWithTag('getTemplateStyleIsOk', res)
        if (res == 1) {
          this.paydialogVisible = false
          this.getMarketModule()
          this.$message.success('模板订购成功')
          this.clearTime()
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    clearTime() {
      clearInterval(this.timer)
      this.timer = null
    }
  }

}
</script>
<style lang="less" scoped>
.page {

  .image-box {
    width: 100%;
    height: 230px;
    overflow: hidden;

    img {
      width: 100%;
      height: auto;
    }
  }

  /deep/ .ant-card-meta-title {
    margin-bottom: 4px;
  }

  /deep/ .ant-card-meta-description {
    height: 44px;
    overflow: hidden;
    line-height: 22px;
  }

  .cardItemContent {
    display: flex;
    height: 20px;
    margin-top: 16px;
    margin-bottom: -4px;
    line-height: 20px;

    > span {
      flex: 1 1;
      color: rgba(0, 0, 0, .45);
      font-size: 12px;
    }

    /deep/ .ant-pro-avatar-list {
      flex: 0 1 auto;
    }

    .price {
      color: #ff7300;
      font-size: 12px;
    }
  }
}

ul, li {
  list-style: none;
}

.lable-ul {
  display: flex;
  align-items: center;
  height: 40px;

  li {
    margin-right: 1%;
    height: 32px;
    line-height: 32px;
    cursor: pointer;
    font-size: 14px;
    padding: 0 5px;
  }

  .active {
    background: #FAAD14;
    color: #fff;
    border-radius: 4px;
  }
}

.lh30 {
  height: 30px;
  line-height: 30px;
}

.price-img {
  width: 300px;
  height: 300px;
  margin: 0 auto;

  img {
    width: 300px;
    height: 300px;
  }
}

.text-txt {
  font-size: 14px;
  text-align: center;
  height: 30px;
  line-height: 30px;
}
</style>